/* import __COLOCATED_TEMPLATE__ from './info-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();